// extracted by mini-css-extract-plugin
module.exports = {"yandexMapContainer":"YandexMap_yandexMapContainer__olCTj","CentredMarker":"YandexMap_CentredMarker__5yBaF"};